// extracted by mini-css-extract-plugin
export default {"container":"UserInfo_container__BjQwm","likeAnimation":"UserInfo_likeAnimation__pfOs-"};